import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  users: [
    {
      id: '1',
      name: 'محمد علي',
      avatar: null,
      lastMessage: 'مرحبا، كيف حالك؟',
      lastMessageTime: '2025/02/04 03:16 PM',
      messages: [
        {
          id: 'm1',
          sender: 'user',
          text: 'مرحبا، كيف حالك؟',
          timestamp: '2025/02/04 03:16 PM',
        },
        {
          id: 'm2',
          sender: 'admin',
          text: 'بخير، كيف أساعدك؟',
          timestamp: '2025/02/04 03:18 PM',
        },
      ],
    },
    {
      id: '2',
      name: 'أحمد حسن',
      avatar: null,
      lastMessage: 'هل متاح غدا؟',
      lastMessageTime: '2025/02/04 03:16 PM',
      messages: [
        {
          id: 'm3',
          sender: 'user',
          text: 'هل متاح غدا؟',
          timestamp: '2025/02/04 03:16 PM',
        },
        {
          id: 'm4',
          sender: 'admin',
          text: 'نعم، متاح بعد الظهر.',
          timestamp: '2025/02/04 03:18 PM',
        },
      ],
    },
  ],
  activeUserId: null,
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setActiveUser: (state, action) => {
      state.activeUserId = action.payload;
    },
    sendMessage: (state, action) => {
      const user = state.users.find((u) => u.id === action.payload.userId);
      if (user) {
        user.messages.push(action.payload.message);
        user.lastMessage = action.payload.message.text;
        user.lastMessageTime = action.payload.message.timestamp;
      }
    },
    clearMessages: (state, action) => {
      const user = state.users.find((u) => u.id === action.payload);
      if (user) {
        user.messages = [];
        user.lastMessage = '';
        user.lastMessageTime = '';
      }
    },
    clearMessagesAll: (state) => {
      state.activeUserId = [];
      state.users = [];
      state.users.forEach((user) => {
        user.messages = [];
        user.lastMessage = '';
        user.lastMessageTime = '';
      });
    },
  },
});

export const { setActiveUser, sendMessage, clearMessages, clearMessagesAll } =
  chatSlice.actions;
export default chatSlice.reducer;
